import styled from 'styled-components/macro'
import { rgba, color } from '../../../utils/styles'

const FormLinks = styled.div`
  margin: 1.5em 0 0;

  a {
    display: inline-block;
    border-radius: 3px;
    padding: 3px;
    text-decoration-color: ${rgba('base', 0.4)};
    transition: text-decoration-color 200ms ease-out,
                background-color 200ms ease-out,
                color 200ms ease-out;

    &:focus {
      background-color: ${color('base')};
      color: ${color('white')};
    }

    &:hover {
      text-decoration-color: ${rgba('base', 1)};
    }
  }
`

export default FormLinks
